import { ref, readonly, onUnmounted } from 'vue'
import { ref as dbRef, onValue } from 'firebase/database'
import { realtimeDb } from '@/firebase/config'

const isOnline = ref(true)
let unsubscribe: (() => void) | null = null
let subscriberCount = 0

export function usePresence() {
  if (subscriberCount === 0) {
    const connectedRef = dbRef(realtimeDb, '.info/connected')
    unsubscribe = onValue(connectedRef, (snapshot) => {
      isOnline.value = snapshot.val() === true
    })
  }
  subscriberCount++

  onUnmounted(() => {
    subscriberCount--
    if (subscriberCount === 0 && unsubscribe) {
      unsubscribe()
      unsubscribe = null
    }
  })

  return { isOnline: readonly(isOnline) }
}
